"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Players_module_css_1 = __importDefault(require("./Players.module.css"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var front_end_validation_1 = __importDefault(require("@nordicscreen/front-end-validation"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var PermissionContext_1 = require("../common/PermissionContext");
var ConnectPlayerModal = function (_a) {
    var isShown = _a.isShown, toggle = _a.toggle;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _b = (0, react_1.useState)({ message: "" }), errors = _b[0], setError = _b[1];
    var _c = (0, react_1.useState)(false), isFormValid = _c[0], setIsFormValid = _c[1];
    var now = new Date();
    var logger = q_play_core_1.logManager.getLogger();
    var _d = (0, react_1.useState)(false), isWebPlayer = _d[0], setIsWebPlayer = _d[1];
    var date = now.toLocaleDateString("eu-DK", { year: "numeric", month: "2-digit", day: "2-digit" }).split("/").reverse().join("-");
    var time = now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false });
    var newPlayerName = "".concat(t("New"), " ").concat(date, " ").concat(time);
    var _e = (0, react_1.useState)(newPlayerName), playerName = _e[0], setPlayerName = _e[1];
    var _f = (0, react_1.useState)(-1), playerGroupId = _f[0], setPlayerGroupId = _f[1];
    var _g = (0, react_1.useState)(null), playerGroups = _g[0], setPlayerGroups = _g[1];
    var _h = (0, react_1.useState)(""), playerConnectCode = _h[0], setPlayerConnectCode = _h[1];
    var userPermissions = (0, react_1.useContext)(PermissionContext_1.PermissionsContext).userPermissions;
    var getPlayerGroups = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response_1, responseData, hasGlobalPlayersManager, allowedGroups, e_1, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.getPlayerGroups()];
                case 1:
                    response_1 = _a.sent();
                    responseData = Object.keys(response_1.data).map(function (key) { return response_1.data[key]; });
                    hasGlobalPlayersManager = userPermissions.some(function (permission) {
                        return permission.name === "global-players-manager" && permission.resourceType === "global";
                    });
                    allowedGroups = hasGlobalPlayersManager ? responseData : responseData.filter(function (group) {
                        return userPermissions.some(function (permission) {
                            return permission.name === "resource-group-manager" && permission.resourceId === group.id;
                        });
                    });
                    setPlayerGroups(allowedGroups);
                    if (allowedGroups.length > 0) {
                        setPlayerGroupId(allowedGroups[0].id);
                    }
                    else {
                        setPlayerGroupId(null);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    error = new Error(e_1.message);
                    logger.error("Getting player groups failed", error);
                    setPlayerGroups([]);
                    setPlayerGroupId(null);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (isShown) {
            setError({ message: null });
            getPlayerGroups();
            setIsWebPlayer(false);
            setPlayerName(newPlayerName);
        }
    }, [isShown]);
    (0, react_1.useEffect)(function () {
        setIsFormValid(!!playerName && playerGroupId !== -1);
    }, [playerName, playerGroupId]);
    var createPlayer = function (name, group) { return __awaiter(void 0, void 0, void 0, function () {
        var requestBody, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    requestBody = {
                        name: name,
                        group: group
                    };
                    return [4 /*yield*/, ApiManager_1.default.genericApiCall("/api/player/create-web-player", "POST", requestBody)];
                case 1:
                    _a.sent();
                    window.dispatchEvent(new CustomEvent("player-created"));
                    toggle();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    logger.error("Error creating player: ", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    function submitCreateWebPlayer(event) {
        event.preventDefault();
        createPlayer(playerName, playerGroupId);
        window.dispatchEvent(new CustomEvent("refresh-user-permissions"));
    }
    var submitConnectCode = function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setError({ message: null });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    if (!playerConnectCode) {
                        throw new Error(t("Connect code is required"));
                    }
                    new front_end_validation_1.default(playerConnectCode).validate("should.have.minLength", t("Connect code should be at least 6 characters"), "6").check();
                    return [4 /*yield*/, ApiManager_1.default.connectPlayer(playerConnectCode, playerName, playerGroupId)];
                case 2:
                    _a.sent();
                    window.dispatchEvent(new CustomEvent("refresh-user-permissions"));
                    window.dispatchEvent(new CustomEvent("player-created"));
                    toggle();
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    if (e_2.constructor === Array && e_2[0].message !== undefined) {
                        setError({ message: e_2[0].message });
                    }
                    else if (playerName && !playerConnectCode) {
                        setError({ message: t("Connect code is required") });
                    }
                    else {
                        console.error(e_2);
                        setError({ message: t("Invalid connect code") });
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: isShown, onClose: toggle, dialogClassName: Players_module_css_1.default.modalDialog, centered: true, body: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { "data-cy": "connectPlayerModal", className: "".concat(Players_module_css_1.default.connect_player_modal_header, " row"), style: { marginBottom: "15px" } },
                react_1.default.createElement("div", { className: "col-sm" }, t("Player details"))),
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-sm" },
                    react_1.default.createElement("label", { htmlFor: "playerName", className: "d-block ns-font-size-15", style: { color: "var(--info-color)" } }, t("Player name")),
                    react_1.default.createElement(q_play_components_1.Input, { placeholder: t("My player"), id: "playerName", dataCy: "playerNameInput", tabIndex: 1, className: Players_module_css_1.default.connect_player_modal_input_field, required: true, value: playerName, onChange: function (e) { setPlayerName(e.target.value); }, onFocus: function (event) { return event.target.select(); }, autoFocus: true })),
                react_1.default.createElement("div", { className: "col-sm" },
                    react_1.default.createElement("label", { htmlFor: "playerGroup", className: "d-block ns-font-size-15", style: { color: "var(--info-color)" } }, t("Group")),
                    react_1.default.createElement(q_play_components_1.Select, { id: "playerGroup", defaultValue: playerGroupId, style: { height: "47px", borderRadius: "4px" }, onChange: function (e) { setPlayerGroupId(Number(e.target.value)); }, "data-cy": "playerGroupSelect", className: "ns-font-size-15" }, playerGroups && playerGroups.map(function (playerGroup) {
                        return react_1.default.createElement("option", { key: playerGroup.id, value: playerGroup.id }, playerGroup.name);
                    })))),
            react_1.default.createElement("div", { className: "".concat(Players_module_css_1.default.connect_player_modal_header, " row"), style: { marginTop: "36.36px", marginBottom: "15px" } },
                react_1.default.createElement("div", { className: "col-sm" }, t("Connect code"))),
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-sm" },
                    react_1.default.createElement("label", { htmlFor: "connectCode", className: "d-block ns-font-size-15", style: { color: "var(--info-color)" } },
                        t("Enter the 'Connect Code' which will be displayed on your screen"),
                        "."),
                    react_1.default.createElement(q_play_components_1.Input, { placeholder: t("Write the connect code here"), id: "connectCode", dataCy: "connectCode", tabIndex: 2, className: Players_module_css_1.default.connect_player_modal_input_field, disabled: isWebPlayer, required: true, value: playerConnectCode, onChange: function (e) { setPlayerConnectCode(e.target.value); }, style: { backgroundColor: isWebPlayer ? "#E0E1E2" : "" } })),
                react_1.default.createElement("div", { className: "col-sm" },
                    react_1.default.createElement("label", { "data-cy": "playerSwitch", htmlFor: "webPlayer", className: "d-block ns-font-size-15", style: { color: "var(--info-color)" } }, t("Create Web Player")),
                    react_1.default.createElement(q_play_components_1.Switch, { id: "webPlayer", value: "webplayer", onChange: function (e) { return setIsWebPlayer(e.target.checked); } }))),
            react_1.default.createElement("div", { className: "row mt-4" },
                react_1.default.createElement("div", { className: "col-sm", style: { color: "var(--info-color)" } },
                    t("Please note that it may take up to 20 seconds before the player is added"),
                    ".")),
            react_1.default.createElement("div", { className: "row mt-2 w-25" },
                react_1.default.createElement("div", { className: "".concat(Players_module_css_1.default.ns_link, " col-sm mt-2") },
                    t("Don't have a player"),
                    "?")),
            react_1.default.createElement("div", { className: "d-flex flex-column justify-content-center align-items-center", style: { marginTop: "25.5px" } },
                react_1.default.createElement(q_play_components_1.Button, { text: isWebPlayer ? t("Create") : t("Connect"), variant: "primary", size: "small", style: { width: "122px" }, onClick: isWebPlayer ? submitCreateWebPlayer : submitConnectCode, isDisabled: !isFormValid, dataCy: "submitButton" }),
                errors.message ? react_1.default.createElement("p", { className: "text-danger m-2" }, errors.message) : null)) }));
};
exports.default = ConnectPlayerModal;
